interface SignUpSubtitleProps {
    text: string
}

export function SignUpSubtitle({ text }: SignUpSubtitleProps) {
    return (
        <div className="tw-mt-8 tw-w-full tw-text-2xl tw-font-medium tw-text-justify tw-text-gray-900 tw-w-[436px]">
            {text}
        </div>
    );
}